import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { io } from 'socket.io-client';

const SOCKET_TOKEN = process.env.REACT_APP_STREAMLABS_SOCKET_TOKEN;

const NotificationStreamLabs = () => {
  useEffect(() => {
    if (!SOCKET_TOKEN) return;

    const socket = io('https://sockets.streamlabs.com', {
      transports: ['websocket'],
      query: { token: SOCKET_TOKEN },
    });

    socket.on('event', (data) => {
      if (!data?.message?.length) return;
      const msg = data.message[0];

      switch (data.type) {
        case 'donation':
          toast.success(`💰 ${msg.name} a fait un don de $${msg.amount} !${msg.message ? ` "${msg.message}"` : ''}`, {
            autoClose: 7000,
          });
          break;
        case 'subscription':
          toast.info(`⭐ ${msg.name} vient de s'abonner !`, { autoClose: 5000 });
          break;
        case 'follow':
          toast(`👋 ${msg.name} te suit maintenant !`, { autoClose: 4000 });
          break;
        default:
          break;
      }
    });

    return () => socket.disconnect();
  }, []);

  return null;
};

export default NotificationStreamLabs;
